import {
	enableIndexedDbPersistence,
	getFirestore,
	type Firestore,
} from "firebase/firestore";
import { app } from "./app";

export const db: Firestore = getFirestore(app);

let persistenceInitPromise: Promise<void> | null = null;

const canInitPersistence = (): boolean => {
	if (typeof window === "undefined") {
		return false;
	}

	return typeof indexedDB !== "undefined";
};

export const initFirestoreOfflinePersistence = async (): Promise<void> => {
	if (!canInitPersistence()) {
		return;
	}

	if (persistenceInitPromise) {
		return persistenceInitPromise;
	}

	persistenceInitPromise = (async () => {
		try {
			await enableIndexedDbPersistence(db);
			console.log(
				"✅ Firestore offline persistence activée (IndexedDB, mode single-tab par défaut)"
			);
		} catch (error) {
			const code = (error as { code?: string })?.code;

			if (code === "failed-precondition") {
				console.warn(
					"⚠️ Firestore persistence non activée: plusieurs onglets détectés (failed-precondition)."
				);
				return;
			}

			if (code === "unimplemented") {
				console.warn(
					"⚠️ Firestore persistence non supportée par ce navigateur (unimplemented)."
				);
				return;
			}

			console.error("❌ Erreur inattendue lors de l'activation de la persistence Firestore:", error);
		}
	})();

	return persistenceInitPromise;
};
